const BOARDS = new Set([
    'barisal',
    'chittagong',
    'comilla',
    'dhaka',
    'dinajpur',
    'jessore',
    'madrasah',
    'mymensingh',
    'rajshahi',
    'sylhet',
    'tec',
]);

const EXAMS = new Set(['jsc', 'ssc', 'hsc', 'dibs']);

function normalizeDigits(value) {
    return String(value)
        .replace(/[০-৯]/g, (digit) => String.fromCharCode(digit.charCodeAt(0) - 0x09e6 + 48))
        .replace(/\D/g, '');
}

/**
 * @param {string} pathname
 * @param {{ board?: string, exam?: string, year?: string, roll?: string, reg?: string }} state
 */
export function buildEducationBoardResultSharePath(pathname, state) {
    const params = new URLSearchParams();
    if (state.board && BOARDS.has(state.board)) params.set('b', state.board);
    if (state.exam && EXAMS.has(state.exam)) params.set('e', state.exam);
    if (state.year) params.set('y', normalizeDigits(state.year));
    if (state.roll) params.set('r', normalizeDigits(state.roll));
    if (state.reg) params.set('reg', normalizeDigits(state.reg));
    const qs = params.toString();
    return qs ? `${pathname}?${qs}` : pathname;
}

/**
 * @param {string} origin
 * @param {string} pathname
 * @param {Parameters<typeof buildEducationBoardResultSharePath>[1]} state
 */
export function buildEducationBoardResultShareUrl(origin, pathname, state) {
    return `${origin}${buildEducationBoardResultSharePath(pathname, state)}`;
}

/**
 * @param {URLSearchParams | string} input
 * @returns {{ board: string, exam: string, year: string, roll: string, reg: string }}
 */
export function parseEducationBoardResultShareParams(input) {
    const params = typeof input === 'string' ? new URLSearchParams(input) : input;
    const board = params.get('b') || '';
    const exam = params.get('e') || '';
    const year = normalizeDigits(params.get('y') || '');
    const roll = normalizeDigits(params.get('r') || '');
    const reg = normalizeDigits(params.get('reg') || '');

    return {
        board: BOARDS.has(board) ? board : '',
        exam: EXAMS.has(exam) ? exam : '',
        year: year && Number(year) >= 1996 ? year : '',
        roll,
        reg,
    };
}

/**
 * @param {{ board?: string, exam?: string, year?: string, roll?: string, reg?: string }} state
 */
export function canShareEducationBoardResult(state) {
    return Boolean(
        state.board
        && state.exam
        && state.year
        && state.roll
        && state.reg,
    );
}
